const addCategoryTarget = () => import('@/views/main/target/category-tagetory/cpns/add-category-target/add-category-target.vue')
export default {
  path: '/main/target/addCategoryTarget',
  name: 'addTarget',
  component: addCategoryTarget,
  children: []
}
